import Link from "next/link";
import React from "react";
import { Skeleton } from "antd";

const loadingData = [1, 2, 3, 4];

const Explore_collection_item = ({
  categoryLoading,
  itemData,
  truncateString,
}) => {

  function getRandomImageFromArray(arr) {
    const randomIndex = Math.floor(Math.random() * arr?.length);
    return arr[randomIndex].image;
  };

  return (
    <>
      {
        categoryLoading
          ?
          loadingData.map((index) => {
            return <Skeleton.Image
              active
              key={index}
              style={{
                width: 270,
                height: 327,
                objectFit: 'cover'
              }}
            />
          })
          :
          itemData?.map((item, index) => {
            return (
              <article key={index}>
                <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                  {/* <Link
                    href={`${item?.id}`}
                    className="flex space-x-[0.625rem]"
                  >
                    <span className="w-[74.5%]">
                      <img
                        width={152}
                        height={242}
                        src={`${process.env.NEXT_PUBLIC_AWS_URL}/${item?.logo}`}
                        // src={item?.logo}
                        alt={item?.name}
                        className="h-full w-full rounded-[0.625rem] object-cover"
                        loading="lazy"
                      />
                    </span>
                    <span className="flex w-1/3 flex-col space-y-[0.625rem]">
                      <img
                        width={68}
                        height={74}
                        src={`${process.env.NEXT_PUBLIC_AWS_URL}/${item?.logo}`}
                        alt={item?.name}
                        className="h-full w-full rounded-[0.625rem] object-cover"
                        loading="lazy"
                      />
                      <img
                        width={68}
                        height={74}
                        src={`${process.env.NEXT_PUBLIC_AWS_URL}/${item?.logo}`}
                        alt={item?.name}
                        className="h-full w-full rounded-[0.625rem] object-cover"
                        loading="lazy"
                      />
                      <img
                        width={68}
                        height={74}
                        src={`${process.env.NEXT_PUBLIC_AWS_URL}/${item?.logo}`}
                        alt={item?.name}
                        className="h-full w-full rounded-[0.625rem] object-cover"
                        loading="lazy"
                      />
                    </span>
                  </Link> */}
                  <Link
                    href={`${item?.id}`}
                    className="flex space-x-[0.625rem]"
                  >
                    <span className="w-[74.5%]">
                      {Array.isArray(item?.artifacts) && item.artifacts.length > 0 ? (
                        <img
                          width={152}
                          height={242}
                          src={`${process.env.NEXT_PUBLIC_AWS_URL}/${item.artifacts.length > 1
                            ? getRandomImageFromArray(item.artifacts)
                            : item.artifacts[0].image
                            }`}
                          alt={item?.name}
                          className="h-full w-full rounded-[0.625rem] object-cover"
                          loading="lazy"
                        />
                      ) : (
                        <img
                          width={152}
                          height={242}
                          src={`${process.env.NEXT_PUBLIC_AWS_URL}/${item?.logo}`}
                          alt={item?.name}
                          className="h-full w-full rounded-[0.625rem] object-cover"
                          loading="lazy"
                        />
                      )}
                    </span>

                    <span className="flex w-1/3 flex-col space-y-[0.625rem]">
                      {[...Array(3)].map((_, index) => (
                        <img
                          key={index}
                          width={68}
                          height={74}
                          src={`${process.env.NEXT_PUBLIC_AWS_URL}/${Array.isArray(item?.artifacts) && item?.artifacts?.length > 1
                            ? getRandomImageFromArray(item?.artifacts)
                            : item?.artifacts?.[0].image
                            }`}
                          alt={item?.name}
                          className="h-full w-full rounded-[0.625rem] object-cover"
                          loading="lazy"
                        />
                      ))}
                    </span>
                  </Link>

                  <Link
                    href={`${item?.id}`}
                    className="font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white"
                  >
                    {item?.name}
                  </Link>

                  <div className="mt-2 flex items-center justify-between text-sm font-medium tracking-tight">
                    <div className="flex flex-wrap items-center">
                      <Link
                        href={`${item?.id}`}
                        className="mr-2 shrink-0">
                        <img
                          width={20}
                          height={20}
                          src={`${process.env.NEXT_PUBLIC_AWS_URL}/${item?.logo}`}
                          alt={item?.name}
                          className="h-5 w-5 rounded-full"
                        />
                      </Link>
                      <span className="dark:text-jacarta-400 mr-1">by</span>
                      <Link
                        href={`${item?.id}`}
                        className="text-accent">
                        <span>{item?.user != null || item?.user != undefined || item?.user !== "" ? item?.user?.userName : truncateString(item?.walletAddress, 8)}</span>
                      </Link>
                    </div>
                    <span className="dark:text-jacarta-300 text-sm">
                      {item?.count} Items
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
    </>
  );
};

export default Explore_collection_item;
